import Phaser from 'phaser';
import { PlatformsSets } from "../constants/PlatformsSets";

/**
 * 
 * @param {number} playerScore
 * @returns {Array.PlatformVariants}
 */
export function getRandomPlatformsSetVariants(playerScore) {

    // Define config by player score
    let platformsSetsConfig;
    if (playerScore < 3000) {
        platformsSetsConfig = PlatformsSets.CONFIG_1;
    } else if (playerScore < 8000) {
        platformsSetsConfig = PlatformsSets.CONFIG_2;
    } else if (playerScore < 11000) {
        platformsSetsConfig = PlatformsSets.CONFIG_3;
    } else if (playerScore < 14000) {
        platformsSetsConfig = PlatformsSets.CONFIG_4;
    } else {
        platformsSetsConfig = PlatformsSets.CONFIG_5;
    }

    // Calculate total chance
    let platformsSetsConfigTotalChance = 0.0;
    platformsSetsConfig.forEach(platformsSet => {
        platformsSetsConfigTotalChance += platformsSet.chance;
    });

    // Get random value for define random platforms set
    const randomValue = Phaser.Math.FloatBetween(0.0, platformsSetsConfigTotalChance);

    // Get random platforms set
    let randomPlatformsSet;
    let leftBorder = 0.0;
    let rightBorder = 0.0;
    platformsSetsConfig.forEach(platformSet => {
        leftBorder = rightBorder;
        rightBorder = rightBorder + platformSet.chance;
        if (randomValue >= leftBorder && randomValue <= rightBorder) {
            randomPlatformsSet = platformSet.platforms;
        }
    });

    return randomPlatformsSet;
}